(() => {
  const roots = document.querySelectorAll('[data-bracelet-product-detail]');

  if (!roots.length) {
    return;
  }

  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th';

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const deliveryEstimate = () => {
    const nowInPT = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    const endOfDay = new Date(nowInPT);
    const futureDate = new Date(nowInPT);

    endOfDay.setHours(23, 59, 59, 999);
    futureDate.setDate(futureDate.getDate() + 21);

    return {
      hours: Math.max(1, Math.floor((endOfDay - nowInPT) / 36e5)),
      date: `${futureDate.toLocaleString('en-US', { month: 'long' })} ${futureDate.getDate()}${suffix(futureDate.getDate())}`
    };
  };

  const setDeliveryEstimate = (root) => {
    const estimate = deliveryEstimate();

    root.querySelectorAll('[data-diamaura-delivery-estimate]').forEach((container) => {
      const hours = container.querySelector('[data-delivery-hours]');
      const date = container.querySelector('[data-delivery-date]');

      if (hours) hours.textContent = estimate.hours;
      if (date) date.textContent = estimate.date;
    });
  };

  const mediaNodes = (root) => ({
    slides: root.querySelectorAll('.product-quick-images__slide[data-media-id]'),
    thumbs: root.querySelectorAll('[data-gallery-thumb]')
  });

  const setMedia = (root, mediaId) => {
    const { slides, thumbs } = mediaNodes(root);
    const target = root.querySelector(`.product-quick-images__slide[data-media-id="${mediaId}"]`);

    if (!target) {
      return;
    }

    slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId));
    thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId));
  };

  const syncMedia = (root) => {
    const active = root.querySelector('.product-quick-images__slide.is-active[data-media-id]');
    const first = root.querySelector('.product-quick-images__slide[data-media-id]');

    setMedia(root, active?.dataset.mediaId || first?.dataset.mediaId);
  };

  const money = (cents) => {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.theme?.settings?.money_with_currency_format);
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  };

  const getVariantData = (selector) => {
    if (!selector.variantData) {
      selector.variantData = JSON.parse(selector.querySelector('script[type="application/json"]')?.textContent || '[]');
    }

    return selector.variantData;
  };

  const selectedOptions = (selector) => {
    return Array.from(selector.querySelectorAll('fieldset')).map((fieldset) => {
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');

      return select ? select.value : checked?.value;
    }).filter(Boolean);
  };

  const selectedVariant = (selector) => {
    const options = selectedOptions(selector);

    return getVariantData(selector).find((variant) => {
      return variant.options.every((option, index) => option === options[index]);
    });
  };

  const updateVariantLabels = (selector, variant) => {
    Array.from(selector.querySelectorAll('fieldset')).forEach((fieldset, index) => {
      const label = fieldset.querySelector('.form__label__value');

      if (label && variant?.options?.[index]) {
        label.textContent = variant.options[index];
      }
    });
  };

  const updatePrice = (root, selector, variant) => {
    const price = root.querySelector(`#price-${selector.dataset.section}`);

    if (!price || !variant) {
      return;
    }

    const current = `<ins><span class="amount">${money(variant.price)}</span></ins>`;
    const compare = variant.compare_at_price && variant.compare_at_price !== variant.price
      ? `<del><span class="amount">${money(variant.compare_at_price)}</span></del>`
      : '';

    price.innerHTML = `<span class="price">${compare}${current}</span>`;
    price.classList.remove('visibility-hidden');
  };

  const updateVariantForm = (root, selector, variant) => {
    if (!variant) {
      return;
    }

    const form = root.querySelector(`#product-form-${selector.dataset.section}`);
    const input = form?.querySelector('input[name="id"]');
    const submitButton = root.querySelector('.single-add-to-cart-button');
    const submitButtonText = submitButton?.querySelector('.single-add-to-cart-button--text');

    if (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (submitButton) {
      submitButton.toggleAttribute('disabled', !variant.available);
      submitButton.classList.toggle('sold-out', !variant.available);
      submitButton.classList.toggle('is-sold-out', !variant.available);
    }

    if (submitButtonText) {
      submitButtonText.textContent = variant.available
        ? window.theme?.variantStrings?.addToCart || 'Add to cart'
        : window.theme?.variantStrings?.soldOut || 'Sold out';
    }
  };

  const updateVariantMedia = (root, selector, variant) => {
    if (!variant?.featured_media?.id) {
      syncMedia(root);
      return;
    }

    setMedia(root, `${selector.dataset.section}-${variant.featured_media.id}`);
  };

  const syncVariant = (root) => {
    const selector = root.querySelector('variant-selects');
    const variant = selector ? selectedVariant(selector) : null;

    if (!selector || !variant) {
      return;
    }

    selector.currentVariant = variant;
    updateVariantLabels(selector, variant);
    updateVariantForm(root, selector, variant);
    updatePrice(root, selector, variant);
    updateVariantMedia(root, selector, variant);

    document.dispatchEvent(new CustomEvent('product:variant-change', {
      detail: {
        variant,
        sectionId: selector.dataset.section
      }
    }));
  };

  const moveMedia = (root, direction) => {
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));

    if (!thumbs.length) {
      return;
    }

    const active = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const next = (active + direction + thumbs.length) % thumbs.length;

    setMedia(root, thumbs[next].dataset.mediaId);
  };

  const bindGallery = (root) => {
    const gallery = root.querySelector('.product-quick-images--container');
    let touchStartX = 0;
    let touchStartY = 0;

    if (!gallery) {
      return;
    }

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');

      if (thumb) {
        setMedia(root, thumb.dataset.mediaId);
      } else if (event.target.closest('[data-gallery-prev]')) {
        moveMedia(root, -1);
      } else if (event.target.closest('[data-gallery-next]')) {
        moveMedia(root, 1);
      }
    });

    gallery.addEventListener('touchstart', (event) => {
      const touch = event.touches?.[0];

      if (!touch) {
        return;
      }

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      const touch = event.changedTouches?.[0];

      if (!touch) {
        return;
      }

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) {
        moveMedia(root, deltaX < 0 ? 1 : -1);
      }
    }, { passive: true });

    syncMedia(root);
  };

  roots.forEach((root) => {
    setDeliveryEstimate(root);
    bindGallery(root);
    syncVariant(root);

    const selector = root.querySelector('variant-selects');

    selector?.addEventListener('change', () => {
      window.setTimeout(() => syncVariant(root));
    });

    selector?.addEventListener('click', () => {
      window.setTimeout(() => syncVariant(root));
    });
  });

  document.addEventListener('product:variant-change', (event) => {
    roots.forEach((root) => {
      const selector = root.querySelector('variant-selects');

      if (selector?.dataset.section === event.detail?.sectionId) {
        window.setTimeout(() => syncMedia(root));
      }
    });
  });
})();
